<template>
  <div id="lm-table-custom">
    <div class="row mb-3">
      <div class="app-search d-xl-block col-md-7">
        <div
          v-if="isVisibleMoreOptions"
          class="app-search__more-options-content p-3"
          @keydown.esc="closeMoreOptions"
          ref="moreOptionsContent"
          tabindex="-1"
          >
          <div class="row ml-2">
            <div class="col-12 pl-0">
              <h6>Buscar en:</h6>
            </div>
          </div>
          <div class="row ml-2" v-if="searchOnFields.length">
            <div
              class="custom-control custom-checkbox col-md-6 mt-1"
              v-for="(option, index) in searchOnFields" :key="index">
                <input
                  class="custom-control-input" type="checkbox"
                  :value="option"
                  :id="option"
                  v-model="apiCall.searchOnFields">
                <label
                  class="custom-control-label"
                  :for="option">
                    {{ keyReadableForHuman(option) }}
                </label>
            </div>
          </div>
          <div class="row" v-if="showFilterTime" >
            <LmDate
              v-model="dateTime.from"
              :placeholder="$t('select_date')"
              :label="$t('min_date')"
              :config="lmDateConfigFrom"
              id="dateTimeFrom"
              :layout="['input-group','col-md-6 mt-3']"
              />
            <LmDate
              v-model="dateTime.upTo"
              :placeholder="$t('select_date')"
              :label="$t('max_date')"
              :config="lmDateConfigUpTo"
              id="dateTimeUpTo"
              :layout="['input-group', 'col-md-6 mt-3']"
              />
          </div>
          <div class="row ml-2">
            <div class="col-5 mt-4 pl-0">
              <button
                @click="cleanOptions"
                v-if="searchOnFields.length && apiCall.searchOnFields.length >= 1"
                type="button"
                class="btn btn-link btn-sm pl-0"
                >{{ $t('clean_options')}}</button>
              <button
                @click="selectAllOptions"
                v-if="searchOnFields.length && apiCall.searchOnFields.length === 0"
                type="button"
                class="btn btn-link btn-sm pl-0"
                >{{ $t('select_all')}}</button>
            </div>
            <div class="col-7 d-flex justify-content-end mt-4">
              <button @click="closeMoreOptions" type="button" class="btn btn-link btn-sm mr-2">{{$t('close')}}</button>
              <button @click="searchItems" type="button" class="btn btn-primary btn-sm">{{$t('search')}}</button>
            </div>

          </div>
        </div>
        <div
          class="input-group"
          @keydown.esc="closeMoreOptions"
          >
          <input
            autofocus
            type="text"
            v-model.trim="apiCall.term"
            class="form-control app-search__main-input"
            @keyup.delete.exact="inputClean"
            @keyup.ctrl.88="inputClean"
            @keyup.enter.exact="searchItems"
            :placeholder="$t('search_placeholder')">
          <span class="mdi mdi-magnify"></span>
          <div class="input-group-append">
            <button
              v-if="showMoreOptions"
              class="btn btn-primary"
              type="button"
              @click="moreOptions">{{$t('more_options')}}</button>
            <button
              v-if="!showMoreOptions"
              class="btn btn-primary"
              type="button"
              @click="searchItems">{{$t('search')}}</button>
          </div>
        </div>
      </div>
      <div class="col-md-5 mt-3 mt-sm-0 col-12 d-flex justify-content-md-end">
        <LmDropdownTableCustom
          :options="orderBySetting"
          :aggregates="aggregates"
          :selectedAgregates = apiCall.aggregates
          :loading = loading
          @dropdownChange="apiCall.orderBy=$event"
          @orderAscDescChanged="apiCall.order=$event"
          @filteredByAggregate="apiCall.aggregates.push($event)"
          @unSelectedAggregate="apiCall.aggregates.splice($event, 1)"
          @cleanAllSelectedAgregates="apiCall.aggregates = []"
          />
      </div>
    </div> <!-- Row -->
    <div class="table-responsive">
      <div class="table-wrapper">
        <LmComponentLoading v-if="loading" ref="lmComponentLoading" :top="top" />
        <table class="table table-striped">
          <thead ref="myThead">
            <tr v-if="tableItems.length">
              <th scope="col" v-for="(el, index) in tableHeader" :key="index">
                <div class="th-wrapper">
                  <span>
                    {{ keyReadableForHuman(el) }}
                  </span>
                  <div class="wrapper-icons" v-if="isOrderly(el)">
                    <font-awesome-icon
                      :class="{ active: activeSortTableHeader(el, 'asc')}"
                      @click="orderByIcon(el, 'asc')"
                      icon="sort-up"
                    />
                    <font-awesome-icon
                      :class="{ active: activeSortTableHeader(el, 'desc')}"
                      @click="orderByIcon(el, 'desc')"
                      icon="sort-down"
                    />
                  </div>
                </div>
              </th>
              <th v-if="actions.length">
                <span>{{$t('actions')}}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!tableItems.length" class="no-search-found-tr">
              <div class="no-search-found">
                <img src="@/assets/images/lumile-logo-no-search.png" alt="lumile-logo" />
                <h1>No se encontraron resultados</h1>
                <h2>Intenta ajustar tu busqueda o filtro para encontrar lo que estás buscando</h2>
              </div>
            </tr>
            <tr v-for="(tr, index) in tableItems" :key="index">
              <td
                v-for="(objContent, key, index) in removeHiddenColumns(tr)"
                :key="index"
                :style="highlightColummnStyles(objContent, key)"
                >
                <span v-if="key !== 'url'" class="font-13 mb-1 font-weight-normal">{{ objContent }}</span>
                <span v-if="key === 'url'" class="font-13 mb-1 font-weight-normal"><a :href="objContent" target="_blank">{{ objContent }}</a></span>
              </td>
              <td class="align-middle" v-if="actions.length">
                  <router-link
                    :to="actionsObj.edit.path + tr[actionsObj.edit.registryId]"
                    v-if="actions.some(e => e.name === 'edit')"
                    class="p-1 d-inline-block">
                    <font-awesome-icon
                      icon="edit"
                      size="lg"
                      class="clickable"
                      />
                  </router-link>
                  <div class="p-1 d-inline-block" v-if="actions.some(e => e.name === 'delete')">
                    <font-awesome-icon
                      icon="trash-alt"
                      size="lg"
                      class="clickable"
                      v-b-modal.deleteModal
                      @click="getSelectedRegistry(tr)"
                      />
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div v-if="tableItems.length" class="showed-items col-md-2 mt-3 align-self-center">
        <p>{{ apiCall.offset + 1 }} {{$t('to')}} {{ apiCall.offset  + tableItems.length }} {{$t('of')}} {{tableItemsTotal}} </p>
      </div>
      <div class="col-md-7 mt-sm-3">
        <LmPagination
          v-if="tableItemsTotal > itemsPerPage "
          :allRegistries="tableItemsTotal"
          :maxAmountItemsShowsPerPaginationInTable="apiCall.limit"
          @paginationNumberClick="getTableItems($event)"
          :maxAmountNumbersToShowInPagination="6"
          />
      </div>
      <div class="input-group col-md-3 mt-3 align-self-start" v-if="false">
        <div class="input-group-prepend">
          <label class="input-group-text" for="inputGroupSelect01"> {{$t('per_page')}} </label>
        </div>
        <select v-model.number="itemsPerPage" class="custom-select" id="inputGroupSelect01">
          <option v-for="(el, i) in perPageSetting" :key="i">{{ el }}</option>
        </select>
      </div>
    </div>
    <b-modal
      id="deleteModal"
      ref="deleteModal"
      title="Eliminar registro"
      title-tag="h3"
      :cancel-title="$t('No')"
      :ok-title="$t('Yes')"
      centered
      lazy
      size="90-percent"
      @ok="ok"
      >
      <p>
        {{$t('delete_register_confirmation')}}
      </p>
      <div class="table-responsive">
        <div class="table-wrapper">
          <table class="table table-striped">
            <thead ref="myThead">
              <tr>
                <th scope="col" v-for="(el, index) in tableHeader" :key="index">
                  <div class="th-wrapper">
                    <span>
                      {{ keyReadableForHuman(el) }}
                    </span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  v-for="(objContent, key, index) in registrySelected"
                  :key="index"
                  :style="highlightColummnStyles(objContent, key)"
                  >
                  <span class="font-13 mb-1 font-weight-normal">{{ objContent }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <LmModalError :message="lmModalError.message"/>
    <LmButton
      v-if="tableItems.length"
      type="button"
      :tooltip="{value:$t('can_not_export_csv'), showOnlyOnDisabled: true}"
      @click.native="exportCsv(tableItemsTotal)"
      value="Export Csv"
      lmButtonRootWrapperClass="d-inline-block"
      lmButtonWrapperClass="col"
      :disabled="tableItemsTotal > exportCsvData.limitExportFromClient"
      :isProcessing="exportCsvData.isLoading"
      />
  </div>
</template>

<script>
import LmPagination from '@/components/LmPagination'
import LmButton from '@/components/form/elements/LmButton'
import LmModalError from '@/components/modals/LmModalError'
import LmDate from '@/components/form/elements/LmDate'
import LmDropdownTableCustom from '@/components/LmDropdownTableCustom.vue'

import { mapState, mapActions } from 'vuex'

import Papa from 'papaparse'
import keyReadableForHuman from '@/helpers/key-readable-for-humans.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSortUp, faSortDown, faEdit, faTrashAlt, faPlusSquare } from '@fortawesome/free-solid-svg-icons'
library.add(faSortUp, faSortDown, faEdit, faTrashAlt, faPlusSquare)

export default {
  components: {
    LmPagination,
    LmButton,
    LmModalError,
    LmDate,
    LmDropdownTableCustom
  },
  data () {
    return {
      isVisibleMoreOptions: false,
      dateTime: {
        from: '',
        upTo: ''
      },
      actionsObj: {
        edit: this.actions.find(element => element.name === 'edit')
      },
      lmModalError: {
        message: ''
      },
      registrySelected: {},
      valueSelectPaginationMobile: 1,
      search: '',
      top: 0,
      exportCsvData: {
        limitExportFromClient: this.limitExportFromClient,
        isLoading: false
      },
      apiCall: {
        path: this.apiCallPath,
        offset: 0,
        limit: this.itemsPerPage,
        term: null,
        order: this.order[0],
        orderBy: this.orderBySetting[0],
        dateFrom: null,
        dateUpTo: null,
        searchOnFields: this.searchOnFields,
        aggregates: []
      }
    }
  },
  props: {
    itemsPerPage: {
      type: Number,
      default: 10
    },
    perPageSetting: {
      type: Array,
      default: function () {
        return [5, 10, 15, 20]
      }
    },
    limitExportFromClient: Number,
    order: {
      type: Array,
      required: true
    },
    'orderBySetting': {
      type: Array,
      required: true
    },
    'searchOnFields': {
      type: Array,
      default: function () {
        return []
      }
    },
    'apiCallPath': {
      type: String,
      required: true
    },
    highlight: {
      type: Object,
      default: function () {
        return {
          column: null,
          background: '#fa5c7c',
          fontColor: 'white'
        }
      }
    },
    actions: {
      type: Array,
      default: function () {
        return []
      }
    },
    showFilterTime: {
      type: Boolean,
      default: false
    },
    downloadCsvFileName: {
      type: String,
      default: 'download'
    }
  },
  computed: {
    ...mapState('commons', ['tableItems', 'csvItems', 'tableItemsTotal', 'loading', 'aggregates']),
    showMoreOptions () {
      return this.searchOnFields.length || this.showFilterTime
    },
    lmDateConfigFrom: function () {
      return {
        maxDate: this.dateTime.upTo || this.lmDateConfigUpTo.maxDate
      }
    },
    lmDateConfigUpTo: function () {
      return {
        maxDate: 'today'
      }
    },
    tableHeader: function () {
      const tableHeaderValues = this.tableItems.map((el) => {
        let keys = Object.keys(el).filter((keyName) => {
          return !keyName.startsWith('hidden_')
        })
        return keys
      })
      return tableHeaderValues[0]
    }
  },
  watch: {
    itemsPerPage: function () {
      this.apiCall.limit = this.itemsPerPage
      this.$nextTick()
        .then(() => {
          this.top = this.$refs.myThead.clientHeight
        })
      this.getTableItems()
    },
    'apiCall.aggregates': function () {
      this.getTableItems()
    },
    'apiCall.order': function () {
      this.getTableItems()
    },
    'apiCall.orderBy': function () {
      this.getTableItems()
    },
    'dateTime.from': function () {
      this.apiCall.dateFrom = this.dateTime.from
    },
    'dateTime.upTo': function () {
      this.apiCall.dateUpTo = this.dateTime.upTo
    }
  },
  methods: {
    ...mapActions('commons', ['getItems', 'getCsvItems']),
    cleanOptions () {
      this.apiCall.searchOnFields = []
      this.dateTime.from = null
      this.dateTime.upTo = null
      this.$refs.moreOptionsContent.focus()
    },
    focus () {
      this.$refs.moreOptionsContent.focus()
    },
    selectAllOptions () {
      this.apiCall.searchOnFields = this.searchOnFields
      this.$refs.moreOptionsContent.focus()
    },
    exportCsv (limit) {
      const apiCallCsV = Object.assign({}, this.apiCall)
      apiCallCsV.limit = limit
      this.exportCsvData.isLoading = true
      this.getCsvItems(apiCallCsV)
        .then((r) => {
          const csv = Papa.unparse(this.csvItems)
          const csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
          let csvURL = null
          if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, `${this.downloadCsvFileName}.csv`)
          } else {
            csvURL = window.URL.createObjectURL(csvData)
          }
          const tempLink = document.createElement('a')
          tempLink.href = csvURL
          tempLink.setAttribute('download', `${this.downloadCsvFileName}.csv`)
          tempLink.click()
        })
        .catch((error) => {
          this.lmModalError.message = error.message
          this.$root.$emit('bv::show::modal', 'errorModal')
        })
        .finally(() => {
          this.exportCsvData.isLoading = false
        })
    },
    ok (bvEvt) {
      bvEvt.preventDefault()
      this.$refs.deleteModal.hide()
    },
    getSelectedRegistry (registry) {
      this.registrySelected = registry
    },
    getTableItems (paginationNumberActivated) {
      if (paginationNumberActivated) {
        this.setApiCallOffset(paginationNumberActivated)
      }
      this.$nextTick()
        .then(() => {
          this.top = this.$refs.myThead.clientHeight
        })
      this.getItems(this.apiCall)
    },
    highlightColummnStyles (objContent, key) {
      if (key === this.highlight.column && objContent === true) {
        return { backgroundColor: this.highlight.background, color: this.highlight.fontColor }
      }
    },
    removeHiddenColumns (row) {
      let rowWithoutHiddenFields = {}
      Object.keys(row).filter((keyName) => {
        // Se quitan las columnas que en su nombre comiencen con hidden_...
        if (!keyName.startsWith('hidden_')) {
          rowWithoutHiddenFields[keyName] = row[keyName]
        }
      })
      return rowWithoutHiddenFields
    },
    isOrderly (el) {
      return this.orderBySetting.includes(el)
    },
    activeSortTableHeader (el, order) {
      return this.apiCall.orderBy === el && this.apiCall.order === order
    },
    orderByIcon (el, order) {
      this.apiCall.orderBy = el
      this.apiCall.order = order
    },
    keyReadableForHuman (key) {
      return keyReadableForHuman(key)
    },
    inputClean () {
      if (!this.apiCall.term) {
        this.getTableItems()
      }
    },
    searchItems () {
      this.getTableItems()
      this.closeMoreOptions()
    },
    moreOptions () {
      this.isVisibleMoreOptions = !this.isVisibleMoreOptions
    },
    closeMoreOptions () {
      this.isVisibleMoreOptions = false
    },
    setApiCallOffset (paginationNumberActivated) {
      this.apiCall.offset = (paginationNumberActivated - 1) * this.apiCall.limit
    }
  },
  mounted () {
    this.getTableItems()
  }
}
</script>

<style lang="sass" scoped>
  .app-search
    padding: 0 15px
    overflow: visible
    @media(max-width: $md)
      margin-top: 1.5rem !important
    input
      border: 1px solid #ced4da !important
    .app-search__more-options-content
      position: absolute
      background: white
      z-index: 11
      width: calc(100% - 30px)
      top: 38px
      box-shadow: 0 2px 4px rgba(0,0,0,0.3)
      border-radius: 0 0 0.25rem 0.25rem
  select
    option
      &::first-letter
        text-transform: uppercase
        color: red
  .table-responsive
    border: none
    @media(max-width: $xl)
      border: 1px solid #dee2e6
    .table-wrapper
      min-height: 100px
      position: relative
      border: 1px solid #dee2e6
      @media(max-width: $xl)
        border: none
    table
      height: 1px
      margin-top: 0 !important
      margin-bottom: 0 !important
      max-width: 100%
      table-layout: fixed
      overflow-wrap: break-word
      @media(max-width: $xl)
        table-layout: auto
      td
        height: 100%
        span
          &.font-13
            font-size: 13px
      thead
        tr
          th
            height: 100%
            position: sticky
            background: white
            top: -1px
            .th-wrapper
              display: flex
              justify-content: space-between
              height: 100%
              span
                align-self: center
              .wrapper-icons
                display: flex
                flex-direction: column
                justify-content: center
                margin-left: 5px
                svg
                  cursor: pointer
                  position: relative
                  opacity: 0.5
                  &.active
                    opacity: 1
    .no-search-found-tr
      background-color: rgba(241, 243, 250, 0.6)
      .no-search-found
        padding: 5%
        img
          margin: 0 auto 30px auto
          display: block
          @media(max-width: $md)
            max-width: 50%
        h1,
        h2
          color: $primaryFontThemeColor
          max-width: 700px
          margin: 0 auto
          text-align: center
          @media(max-width: $md)
            min-width: 100px
        h1
          font-size: 24px
          margin-bottom: 10px
          @media(max-width: $md)
            font-size: 18px
        h2
          font-size: 18px
          @media(max-width: $md)
            font-size: 14px

</style>
